
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'
import {
  isItTicketType
} from '@/utils/commonFunc'
@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({
    default: () => {
      return {}
    }
  }) private node!: any

  @Prop({
    default: () => {
      return {}
    }
  }) private allBuilding!: any

  @Prop({
    default: () => {
      return {}
    }
  }) private allTeams!: any

  private isEditMode = false
  private isDisableSubmit = false
  private testResult = false
  private props = {
    multiple: true,
    value: 'id',
    label: 'label'
  }

  private userInputValue = ''
  private formData = {
    role: 0,
    id: 0,
    name: '',
    webhook: '', // 机器人
    secret: '', // 机器人密钥
    buildings: [], // 基地
    users: [], // 用户
    team: null // 团队
  }

  private formatBuilding = []
  private formatTeam = [this.formData.team]

  private rules = {
    name: [{ required: true, message: '请输入群组名称', trigger: 'blur' }],
    webhook: [{ required: true, message: '请输入群组机器人', trigger: 'blur' }],
    secret: [{ required: true, message: '请输入群组机器人密钥', trigger: 'blur' }],
    buildings: [{ required: true, message: '至少选择一个基地', trigger: 'change' }],
    users: [{ required: true, message: '至少选择一个用户', trigger: 'change' }]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.groupAddDialog
  }

  get isItTicketType() {
    return isItTicketType()
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        this.formData = {
          role: 2, // 只能新增保障角色的群组
          id: 0,
          name: '',
          webhook: '',
          secret: '',
          buildings: [],
          users: [],
          team: null
        }
      } else if (this.type === 'edit') {
        this.formData = JSON.parse(JSON.stringify(Object.assign({}, this.node)))
        this.node.buildings.map((item: any, index: number) => {
          (this.formData.buildings as any)[index] = ['place_' + item.place, 'building_' + item.id]
        })
        this.formatBuilding = []
        // debugger
        // 初始化 team 字段
        if (this.node.team && Array.isArray(this.node.team)) {
          if (this.node.team[0]) {
            this.formData.team = this.node.team[0].id // 由于是单选，取第一个团队 ID
          }
        } else {
          this.formData.team = null // 初始化为空数组
        }
        this.isEditMode = true
        this.formatTeam = []
      }
      this.testResult = false
      if (this.isItTicketType) {
        delete this.rules.buildings
      } else {
        this.rules.buildings = [{ required: true, message: '至少选择一个基地', trigger: 'change' }]
      }
    }
  }

  // 测试机器人是否有效，向知音楼群发测试消息
  handleRobotTest(formName: string) {
    // eslint-disable-next-line eqeqeq
    if (this.formData.webhook == '' || this.formData.secret == '') {
      (this.$refs[formName] as any).validateField(['webhook', 'secret'])
    } else {
      this.isDisableSubmit = true
      CONFIGAPI.testGroupRobot({
        webhook: this.formData.webhook,
        secret: this.formData.secret
      }, {
        app_id: this.userCurrentApp
      }).then((res) => {
        if (res.stat === 1) {
          this.testResult = true // 测试成功icon
          this.$message.success(res.data + '，可前往知音楼群查看测试通知')
        }
        this.isDisableSubmit = false
      }).catch((error) => {
        console.log('发生错误！', error)
        this.isDisableSubmit = false
        this.testResult = false
      })
    }
  }

  // 删除用户
  handleDelUser(index: number) {
    this.formData.users.splice(index, 1)
  }

  // 用户姓名/工号输入建议
  querySearchUser(queryString: string, callback: any) {
    CONFIGAPI.getUsersData({
      key: queryString
    }).then((res) => {
      if (res.stat === 1) {
        callback(res.data)
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 添加用户
  handleAddUser(user: any) {
    const isRepeat = this.formData.users.some((item: any) => {
      return item.workcode === user.workcode
    })
    if (user && !isRepeat) {
      (this.formData.users as any).push(user)
    }
    this.userInputValue = ''
  }

  // 提交按钮触发
  private handleSubmit(formName: string): void {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        this.formData.buildings.forEach((item: any, index) => {
          (this.formatBuilding as any)[index] = (item[1] as any).split('_')[1]
        })
        if (this.formData.team !== null) {
          this.formatTeam = [this.formData.team] // 将单一团队 ID 转换为数组
        }
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addGroup({
      role: this.formData.role,
      webhook: this.formData.webhook,
      secret: this.formData.secret,
      buildings: this.formatBuilding,
      yach_users: this.formData.users,
      name: this.formData.name,
      team: this.formatTeam
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'groupAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editGroup({
      role: this.formData.role,
      webhook: this.formData.webhook,
      secret: this.formData.secret,
      buildings: this.formatBuilding,
      yach_users: this.formData.users,
      name: this.formData.name,
      id: this.formData.id
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'groupAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'groupAddDialog',
      value: false
    })
  }
}
